var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 9.2 4.6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 0L4.6 4.6 0 0h9.2z",
    fill: "#292f35"
  })));
}

export default SvgDropdown;